// extracted by mini-css-extract-plugin
export default {"container":"DownloadsList_container__D7kdb","cardContainer":"DownloadsList_cardContainer__v9oND"};